import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=20db20b8"
import script from "./AddCampaign.vue?vue&type=script&lang=js"
export * from "./AddCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports